import { Box, Card } from '@nimbus-ds/components';
import { ProductTransferDetailsResponseDto } from '@tiendanube/common';
import { useResponsive } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { TransferList, TransferTable } from '../../components';

type ProductVariant =
  ProductTransferDetailsResponseDto['productVariants'][number];

interface ProductsTransferCardProps {
  productVariants: ProductVariant[];
}

function ProductsTransferCard({
  productVariants,
}: Readonly<ProductsTransferCardProps>) {
  const t = useTranslationCatalog();
  const { isMobile } = useResponsive();

  return (
    <Card>
      <Card.Header title={t('transfers.new.products.title')} />
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="4">
          {isMobile ? (
            <TransferList productVariants={productVariants} />
          ) : (
            <TransferTable productVariants={productVariants} />
          )}
        </Box>
      </Card.Body>
    </Card>
  );
}

export default ProductsTransferCard;
